// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3x-1";
export var rateTableServiceLevelDropdown = "_3x-3";
export var rateTableTypeDropdown = "_3x-0";
export var rateTableValueModeDropdown = "_3x-2";